module.exports = __webpack_public_path__ + "img/421e050.jpg";